import * as React from 'react';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { Link } from 'react-router-dom';
import { Tooltip } from 'reactstrap';

// COMPONENTS
import CircleImage from '../../components/CircleImage';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert-circle.svg';

// TYPES
interface RoleListItemTypes {
	roleId?: string;
	profileImage?: string;
	firstName?: string;
	lastName?: string;
	staffType?: string;
	isYou?: boolean;
	role?: string;
	canUpdate?: boolean;
	needsAttention?: boolean;
	isPastStaff?: boolean;
}

const RoleListItem: React.FC<RoleListItemTypes> = ({
	profileImage,
	canUpdate,
	roleId,
	firstName,
	lastName,
	staffType,
	isYou,
	needsAttention,
	isPastStaff
}) => {
	const staffTypes = useAppSelector((state) => state.lists.staffTypes);
	const userIsAdmin = useAppSelector((state) => state.user.isOrganisationAdmin);

	const [incompleteProfileTooltipOpen, setincompleteProfileTooltipOpen] = React.useState<boolean>(false);

	const toggleincompleteProfileTooltip = () => setincompleteProfileTooltipOpen(!incompleteProfileTooltipOpen);

	const staffTypesLookup: {
		[key: string]: string | undefined;
	} = {};

	if (staffTypes) {
		staffTypes.forEach((type) => {
			if (type && type.value) {
				staffTypesLookup[type.value] = type.label;
			}
		});
	}

	return (
		<div className="row-container" key={roleId || '' + firstName + lastName + staffType}>
			<div className="row detail-row">
				<div className="col-auto pdl-0 pdr-0">
					<CircleImage
						src={profileImage}
						size={40}
						firstName={firstName}
						lastName={lastName}
						isColorBorder={true}
						isProfileInComplete={needsAttention}
					/>
				</div>

				<div className="col-md-auto full-width">
					<div className="row detail-info">
						<div className="col-lg-3 detail-name">
							{firstName} {lastName} {isYou && <strong>(You)</strong>}
						</div>

						<div className="col-lg-3 detail-status">
							<div className="status">{staffTypesLookup[staffType || ''] || staffType}</div>
						</div>
					</div>
				</div>

				<div className="col-auto pdr-0 link-group">
					{isYou ? (
						<Link className="btn-text pdr-0" to={`/staff/${roleId}`}>
							Edit
						</Link>
					) : userIsAdmin && isPastStaff === false ? (
						<Link className="btn-text pdr-0" to={`/staff/${roleId}`}>
							View
						</Link>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default RoleListItem;
